import { DocumentSnapshot, DocumentData } from "firebase/firestore";

export type { CollectionReference, DocumentData, DocumentSnapshot } from "firebase/firestore";
export { DocumentReference, FieldValue, Timestamp, arrayUnion } from "firebase/firestore";

export function snapshotExists<AppModelType = DocumentData, DbModelType extends DocumentData = DocumentData>(snapshot: DocumentSnapshot<AppModelType, DbModelType>): boolean {
    return snapshot.exists();
}